import { render } from "./MessageBoxs.vue?vue&type=template&id=664d8bcf&scoped=true"
import script from "./MessageBoxs.vue?vue&type=script&lang=js"
export * from "./MessageBoxs.vue?vue&type=script&lang=js"

import "./MessageBoxs.vue?vue&type=style&index=0&id=664d8bcf&scoped=true&lang=css"

import exportComponent from "D:\\Git仓库\\象新力官网\\html_xxldx_xxlx_xxlg\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-664d8bcf"]])

export default __exports__